import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { vapidPublicKey: String }
  static targets = ["bell"]

  connect() {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      this.element.style.display = "none"
      return
    }

    this.element.style.display = ""
    this._checkSubscription()
  }

  async toggle() {
    const registration = await navigator.serviceWorker.ready
    const subscription = await registration.pushManager.getSubscription()

    if (subscription) {
      await this._unsubscribe(subscription)
    } else {
      await this._subscribe(registration)
    }
  }

  async _checkSubscription() {
    const registration = await navigator.serviceWorker.ready
    const subscription = await registration.pushManager.getSubscription()
    this._updateUI(!!subscription)
  }

  async _subscribe(registration) {
    try {
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: this._urlBase64ToUint8Array(this.vapidPublicKeyValue)
      })

      const json = subscription.toJSON()
      const token = document.querySelector('meta[name="csrf-token"]')?.content

      await fetch("/push_subscriptions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token
        },
        body: JSON.stringify({
          endpoint: json.endpoint,
          p256dh: json.keys.p256dh,
          auth: json.keys.auth
        })
      })

      this._updateUI(true)
    } catch (err) {
      if (Notification.permission === "denied") {
        alert("Notificações bloqueadas. Permita nas configurações do navegador.")
      }
    }
  }

  async _unsubscribe(subscription) {
    await subscription.unsubscribe()

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    await fetch("/push_subscriptions", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ endpoint: subscription.endpoint })
    })

    this._updateUI(false)
  }

  _updateUI(subscribed) {
    this.bellTargets.forEach(bell => {
      const label = bell.querySelector("span") ? " Push" : ""
      bell.innerHTML = subscribed
        ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>' + label
        : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/><line x1="1" y1="1" x2="23" y2="23"/></svg>' + label
      bell.classList.toggle("push-bell--active", subscribed)
    })
  }

  _urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - base64String.length % 4) % 4)
    const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/")
    const rawData = atob(base64)
    const outputArray = new Uint8Array(rawData.length)
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray
  }
}
